<template>
  <div :key="updateComponent" class="row justify-center">

    <q-btn flat size="xs" class="no-margin text-monumental" push dense>
      <q-img v-if="this.$i18n.locale" style="border: 2px solid white;color: white; width: 16px; height: 12px"
             :src="'https://flagcdn.com/h20/'+computeFlag(this.$i18n.locale) +'.png'"

      />
      <q-popup-proxy>
        <q-card square dark class="text-white" v-if="!closing">
          <q-item clickable v-close-popup @click.stop="updateLanguage(locale.value)" v-for="(locale, idx) in localeOptions" v-bind:key="idx">
            <q-item-section avatar>
              <q-img style="width: 20px; height: 16px"
                     :src="'https://flagcdn.com/h20/'+locale.flag+'.png'"/>
            </q-item-section>
            <q-item-section>
              <q-item-label>{{ locale.label }}</q-item-label>
            </q-item-section>
          </q-item>

        </q-card>
      </q-popup-proxy>

    </q-btn>

  </div>

</template>
<script>
import {useAuthStore} from '@core/stores/authStore';
import {mapStores} from 'pinia'
import {useLayoutStore} from '@core/stores/layoutStore';
import EventBus from '@core/services/utils/appEventBusService';
import BusEnum from '@core/enums/BusEnum';
import AppModelService from '@core/services/app/appModelService';

import quasarFr from 'quasar/lang/fr'
import quasarEn from 'quasar/lang/en-US'
import quasarDe from 'quasar/lang/de-DE'


export default {
  name : "app-language",
  data() {
    return {
      closing : false,
      showIssueNew : false,
      updateComponent: 0,
      isOpen: false,
      showSurvey: false,
      activities: [],

      showOnboarding : false,
      //
      locale : this.$i18n.locale,
      localeOptions: [],
      quasarLanguages: {
        'fr': quasarFr,
        'en': quasarEn,
        'de': quasarDe,
      }
    };
  },
  components: {},
  computed: {
    ...mapStores(useAuthStore, useLayoutStore),

  },
  methods: {
    async loadLanguages() {
      try {
        const models = await AppModelService.findByCategory('APP_LANGUAGE');
        if (models && models.length > 0) {
          this.localeOptions = models.map(model => ({
            value: model.code,
            label: this.$t(model.i18n),
            flag: this.codeToFlag(model.code)
          }));
        }
      } catch (error) {
        console.error('[AppLanguage] Error loading languages:', error);
        // Fallback to default languages
        this.localeOptions = [
          { value: 'en', label: 'English', flag: 'gb' },
          { value: 'fr', label: 'Français', flag: 'fr' }
        ];
      }
    },
    codeToFlag(code) {
      const mapping = { 'en': 'gb' };
      return mapping[code] || code;
    },
    computeFlag(locale) {
      let option= this.localeOptions.find((v)=> v.value===locale)
      if(option) {
        return option.flag
      }
      else {
        return "gb"
      }
    },
    updateLanguage(lang) {
      this.$i18n.locale = lang
      this.layoutStore.updateLanguage(lang)

      const quasarLang = this.quasarLanguages[lang] || this.quasarLanguages['fr'];
      this.$q.lang.set(quasarLang);

      EventBus.emit(BusEnum.LANGUAGE_UPDATE, lang);

    },

  },
  created() {
    this.loadLanguages();
  }
};
</script>

<style lang="scss">
</style>
